import { Skeleton } from 'antd';
import clsx from 'clsx';

interface ListItemLoadingProps {
    type?: 'avatar' | 'text';
    className?: string;
}

export function ListItemSkeleton({
    type = 'text',
    className,
}: Readonly<ListItemLoadingProps>) {
    return (
        <div
            className={clsx(
                'w-full min-h-screen p-6 space-y-6 bg-white',
                className
            )}
        >
            {[...Array(5)].map((_, i) => (
                <div key={i} className="w-full p-4 rounded-lg space-y-4">
                    {type === 'avatar' ? (
                        <div className="flex items-center w-full space-x-4">
                            <Skeleton.Avatar active size={32} shape="circle" />
                            <div className="flex flex-col flex-1 space-y-2">
                                <Skeleton.Input
                                    active
                                    size="small"
                                    className="!w-full rounded-lg"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col w-full justify-center space-y-2">
                            <Skeleton.Input
                                active
                                size="default"
                                className="!w-full rounded-lg h-6"
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
